<template>
  <v-dialog fullscreen v-model="isOpen">
    <div :class="$style.tooltipArea" data-tooltip-area>
      <div>
        <div :class="$style.headerArea" class="text-xs-right">
          <button :class="$style.closeButton" @click="isOpen = false">
            <closeIcon :class="$style.closeButton__icon"></closeIcon>
          </button>
        </div>

        <div :class="$style.tooltipArea__item">
          <img
            :class="$style.tooltipArea__imageSize"
            :src="tutorialImagePath"
          />
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Locale from "../../../lib/locale";

// 各言語の使い方画像
import DeWallTutorial from "../../../assets/ViewerTooltip/de_wall_tutorial.png";
import EnWallTutorial from "../../../assets/ViewerTooltip/en_wall_tutorial.png";
import EsWallTutorial from "../../../assets/ViewerTooltip/es_wall_tutorial.png";
import FrWallTutorial from "../../../assets/ViewerTooltip/fr_wall_tutorial.png";
import JaWallTutorial from "../../../assets/ViewerTooltip/ja_wall_tutorial.png";
import KoWallTutorial from "../../../assets/ViewerTooltip/ko_wall_tutorial.png";
import TcWallTutorial from "../../../assets/ViewerTooltip/tc_wall_tutorial.png";

// 閉じるアイコン
import closeIcon from "../../../assets/common/close_icon.svg";

export default {
  name: "vc-share-viewer-usage-dialog",
  components: {
    closeIcon: closeIcon
  },
  data: function() {
    return {
      isOpen: false,
      locale: Locale.getLocale(),
      tutorialImagePath: ""
    };
  },
  mounted() {
    window.addEventListener("message", event => {
      if (event.data.event === "openTooltip") {
        this.isOpen = true;
        const tooltipAreaElement = document.querySelector(
          "[data-tooltip-area]"
        );
        tooltipAreaElement.addEventListener(
          "click",
          () => {
            this.isOpen = false;
            tooltipAreaElement.removeEventListener("click", () => {}, false);
          },
          false
        );
      }
    });

    this.setTutorialImagePath();
  },
  methods: {
    setTutorialImagePath() {
      switch (this.locale) {
        case "de-de":
          this.tutorialImagePath = DeWallTutorial;
          break;
        case "en-us":
        default:
          this.tutorialImagePath = EnWallTutorial;
          break;
        case "es-es":
          this.tutorialImagePath = EsWallTutorial;
          break;
        case "fr-fr":
          this.tutorialImagePath = FrWallTutorial;
          break;
        case "ja-jp":
          this.tutorialImagePath = JaWallTutorial;
          break;
        case "ko-kr":
          this.tutorialImagePath = KoWallTutorial;
          break;
        case "zh-tw":
          this.tutorialImagePath = TcWallTutorial;
          break;
      }
    }
  }
};
</script>

<style module lang="scss">
.headerArea {
  width: 100%;
}

.closeButton {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 6px 8px;
  background-color: transparent;
  border-style: none;
  cursor: pointer;
  outline: 0;

  &__icon {
    fill: white;
    vertical-align: middle;
  }
}
.closeButton:hover {
  border-radius: 50%;
  background-color: rgba(33, 33, 2, 0.46);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
}

.tooltipArea {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(33, 33, 2, 0.46);
  cursor: pointer;
  flex-wrap: wrap;

  @media screen and (max-height: 600px) and (orientation: landscape) {
    align-items: start;
  }

  &__item {
    max-width: 500px;
    padding: 0 8px;

    @media screen and (max-height: 600px) and (orientation: landscape) {
      max-width: 200px;
    }
  }

  &__imageSize {
    width: 100%;
    height: auto;
  }
}
</style>
